import { ThemeColors } from '~/themes/colors'

export interface FloatinMenuColors {
  Background: ThemeColors
  Option: {
    Background: {
      Default: ThemeColors
      Active: ThemeColors
      Hover: ThemeColors
    }
    FontColor: ThemeColors
    IconColor: ThemeColors
  }
}

export const floatingMenuColors: FloatinMenuColors = {
  Background: {
    default: 'gray.100',
  },
  Option: {
    Background: {
      Default: {
        default: 'achromatic.inherit',
      },
      Active: {
        default: 'gray.300',
      },
      Hover: {
        default: 'gray.400',
      },
    },
    FontColor: {
      default: 'gray.1300',
    },
    IconColor: {
      default: 'gray.1300',
    },
  },
}
